module.exports = __webpack_public_path__ + "images/load-blue-3b04cd9e.svg";